<script setup lang="ts">
import AppButton2 from '~/components/AppButton2.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Sliders/L Text R Slider4'
const component_default_values: CmsCustomComponentType = {
  background: { value: undefined, selectValues: ['bg-background-2', 'bg-background-1', 'bg-white'], default_value: 'bg-background-2', settingType: 'select', setting_label: 'zmien tło' },
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-10 px-xl xl:pl-2xl flex flex-col xl:grid grid-cols-12 gap-8 xl:gap-16"
      :class="component_values?.background?.value ?? component_values?.background?.default_value"
    >
      <div class="flex flex-col gap-10 col-span-5">
        <CmsImage
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'image_1']"
          class="w-36 h-30"
        />
        <span class="text-H2 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
          />
        </span>
        <span class="text-H4 text-Tekst">
          <div class="flex flex-col gap-10">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
            />
          </div>
        </span>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
        >
          <AppButton2
            :href="link?.href"
            :target="link?.target"
          >
            <span class="link-text">{{ link?.link_text ?? 'Lorem Ipsum' }}</span>
          </AppButton2>
        </CmsLink>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 xl:pt-24 xl:col-span-7"
      >
        <RSliderComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_2', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
